import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import React, { useState } from 'react';
import VideoControlButton from './VideoControlButton';
import VolumeSlider from './VolumeSlider';
import { useIntl } from 'react-intl';
import { faVolume } from '@fortawesome/pro-regular-svg-icons/faVolume';
import { faVolumeHigh } from '@fortawesome/pro-regular-svg-icons/faVolumeHigh';
import { faVolumeLow } from '@fortawesome/pro-regular-svg-icons/faVolumeLow';
import { faVolumeSlash } from '@fortawesome/pro-regular-svg-icons/faVolumeSlash';

import { useVideoPlayer } from '../../context/VideoPlayerProvider';
import useModal from '../../hooks/useModal';

/**
 * Get current volume icon.
 */
const getVolumeIcon = (volume: number) => {
  if (volume > 0.8) return faVolumeHigh;
  if (volume === 0) return faVolumeSlash;
  if (volume < 0.3) return faVolumeLow;

  return faVolume;
};

/**
 * Volume controls.
 */
const VolumeControls = () => {
  const intl = useIntl();
  const { volume, setVolume } = useVideoPlayer();
  const slider = useModal();

  const icon = getVolumeIcon(volume);

  const [previousVolume, setPreviousVolume] = useState(volume);

  const handleClickVolume = () => {
    if (volume) {
      setPreviousVolume(volume);
      setVolume(0);
    } else {
      setVolume(previousVolume);
    }
  };

  return (
    <Box cn="">
      <Box
        data-testid="volume-controls-wrapper"
        cn="flex items-center"
        onMouseEnter={() => slider.show()}
        onMouseLeave={() => slider.hide()}
        onFocus={() => slider.show()}
        onBlur={() => slider.hide()}
      >
        <VideoControlButton
          icon={<Icon icon={icon} />}
          data-testid="volumne-slider-button"
          onClick={handleClickVolume}
          ariaLabel="volume"
          tooltipText={intl.formatMessage({
            id: 'video_control_bar.volume',
            defaultMessage: 'Volume',
          })}
        />

        <Box
          data-testid="volume-slider-wrapper"
          cn={`${
            slider.isVisible ? 'opacity-100' : 'opacity-0'
          } transition-all`}
          onBlur={() => slider.hide()}
          onFocus={() => slider.show()}
        >
          <VolumeSlider />
        </Box>
      </Box>
    </Box>
  );
};

export default VolumeControls;
